<div class="login-wrapper">

  <div class="login-card">

    <h2>{{ t('login') }}</h2>

    <!-- 🔵 GOOGLE SOCIAL LOGIN -->
    <!-- 🔷 FACEBOOK বাটন আপাতত বন্ধ রাখা হলো — Facebook App এখনো
         Business Verification / App Review-এর অপেক্ষায় আছে (Live
         মোডে যায়নি), তাই এই মুহূর্তে চালু রাখলে সাধারণ ইউজাররা
         ব্যবহার করতে পারবে না। Verification শেষ হলে নিচের
         commented-out বাটনটা আবার চালু করে দিলেই হবে — বাকি
         backend/login.ts কোড অপরিবর্তিত আছে। -->
    <div class="social-login">

      <!-- Google renders its own official button here -->
      <div #googleBtn class="google-btn-slot"></div>

      <!--
      <button
        type="button"
        class="facebook-btn"
        (click)="facebookLogin()"
        [disabled]="socialLoading">
        <i class="fa-brands fa-facebook-f"></i>
        {{ t('continueWithFacebook') }}
      </button>
      -->

    </div>

    <div class="divider">
      <span>{{ t('orDivider') }}</span>
    </div>

    <!-- ✉️ EMAIL + PASSWORD LOGIN -->
    <form (ngSubmit)="submit()">

      <input
        [(ngModel)]="email"
        name="email"
        id="email"
        type="email"
        autocomplete="username"
        [placeholder]="t('emailLabel')"
        required>

      <!-- 🔐 PASSWORD WITH EYE -->
      <div class="password-field">

        <input
          [(ngModel)]="password"
          name="password"
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          autocomplete="current-password"
          [placeholder]="t('password')"
          required>

        <span class="eye" (click)="togglePassword()">
          {{ showPassword ? '🙈' : '👁️' }}
        </span>

      </div>

      <button type="submit" [disabled]="loading">
        {{ loading ? t('loggingIn') : t('login') }}
      </button>

      <div class="forgot-link">
        <a routerLink="/forgot-password">{{ t('forgotPasswordTitle') }}</a>
      </div>

      <div class="register-link">
        <span>{{ t('dontHaveAccount') }}</span>
        <a routerLink="/register">{{ t('createAccount') }}</a>
      </div>

    </form>

  </div>

</div>
